import { FunctionComponent, ReactElement } from 'react';
import { Helmet } from 'react-helmet-async';

import { useThemeConfig } from './hooks/use-theme-config/use-theme-config.hook';

export const PageHead: FunctionComponent = (): ReactElement => {
  const themeConfig = useThemeConfig();

  return (
    <Helmet>
      {themeConfig?.appTitle && <title>{themeConfig.appTitle}</title>}
      {themeConfig?.faviconPath && (
        <link id="favicon" rel="icon" href={themeConfig.faviconPath} />
      )}
    </Helmet>
  );
};
